import { Button, darken, styled } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';
import { ButtonTypeMap } from '@mui/material/Button/Button';

export const StyledButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  padding: theme.spacing(1.25, 2),
  fontSize: 13,
  fontWeight: 600,
  color: darken(theme.palette.common.white, 0.2),
  borderRadius: 4,
  '&:hover, &.MuiSelected': {
    color: theme.palette.common.white,
    backgroundColor: '#2C3344',
  },
  '& svg': {
    '&:first-of-type': {
      marginRight: theme.spacing(2),
    },
  },
})) as OverrideProps<ButtonTypeMap<any, any>, any>;
